import { getIsDebugEnvironment } from './getIsDebugEnvironment';

export const getApolloDevToolsEnabled = () => {
    return getIsDebugEnvironment();
};
